import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'searchFilter'
})

@Injectable()
export class SearchFilterPipe implements PipeTransform {
    transform(items: any[], value: string): any[] {
        if (!items) return [];
        if (!value) return items;
        return items.filter(item => {
            let exist = false;
            for (let key in item) {
                if (item[key] && (item[key] + '').toLowerCase().includes(value.toLowerCase())) {
                    exist = true;
                    break;
                }
            }
            return exist;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/filter/searchFilterPipe.ts